var CaptchaCode;

var createCaptcha = function () {
    if (!document.getElementById('captcha-basic')) {
        return;
    }
    document.getElementById('captcha-basic').innerHTML = "";

    // 0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@!#$%^&*
    var charsArray =
        "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

    var lengthOtp = 6;
    var captcha = [];
    for (var i = 0; i < lengthOtp; i++) {
        var index = Math.floor(Math.random() * charsArray.length + 1);
        if (captcha.indexOf(charsArray[index]) == -1)
            captcha.push(charsArray[index]);
        else i--;
    }
    var canv = document.createElement("canvas");
    canv.id = "captcha";
    canv.width = 160;
    canv.height = 60;
    var ctx = canv.getContext("2d");
    ctx.font = "40px Georgia";

    var themeColorMetaTag = document.querySelector('meta[name="theme-color"]');
    if (themeColorMetaTag) {
        var themeColor = themeColorMetaTag.getAttribute("content");
        ctx.strokeStyle = themeColor;
    } else {
        ctx.strokeStyle = "#f997b7";
    }

    var captchaText = captcha.join("");
    var textWidth = ctx.measureText(captchaText).width;
    var xOffset = (canv.width - textWidth) / 2;
    var yOffset = (canv.height / 2) + 10;
    ctx.strokeText(captchaText, xOffset, yOffset);

    CaptchaCode = captchaText;
    document.getElementById("captcha-basic").appendChild(canv);
}
createCaptcha();


export function validateCaptcha() {
    if (document.getElementById("captcha-input").value == CaptchaCode) {
        document.getElementById("captcha-input").value = '';
        createCaptcha();
        return true;
    } else {
        createCaptcha();
        return false;
    }
}